<template>
<Form :label-width="80" class="mt15 w1000">
    <FormItem>
    	<div class="desc">
    		投保人声明：请下载投保重要事项确认书拍照上传，
			<a href="/static/pdf/meiya/投保重要事项确认书.pdf" target="_blank">下载</a>
    	</div>
    	<Form class="policy" :model="form" ref="form" :label-width="0">
    		<Form-item 
    			class="policy-item" 
    			v-for="(p,i) in form.fileList"
    			:prop="'fileList.' + i + '.fileUrl'"
    			:key="i"
    			:rules="{required:true,message:'请上传',trigger:'change'}">
    			<UploadImg 
    				v-model="p.fileUrl" 
    				@on-remove="removeImg(i)"
					@on-success="val=>{uploaded(val, i)}"
    				:show-del="form.fileList.length>1" />
    			<Input v-model="p.fileUrl" v-show="false"></Input>
    		</Form-item>
    		<div class="policy-item" v-if="multiple&&form.fileList.length<10">
    			<a @click="add">点击上传</a>
    		</div>
    	</Form>
    </FormItem>
</Form>
</template>
<script>
import UploadImg from './UploadImg'
export default {
	components:{ UploadImg },
	props:{ 
		info:Object,
		multiple:Boolean
	},
	data () {
		return{
			form:{
				fileList:this.info.fileList.length>0?this.info.fileList:[{
					fileUrl:''
				}]
			}
		}
	},
	methods:{
		uploaded(file, index){
			let obj = {
				fileUrl:file.url,
				fileName:file.name,
				fileType:'APPLICATION'
			}
			this.$set(this.form.fileList, index, obj)
		},
		async val () {
			let flag = await this.$refs.form.validate();
			if(!flag)return;
			return new Promise((resolve,reject)=>{
				resolve(this.form)
			})
		},
		add () {
			this.form.fileList.push({
				fileUrl:''
			})
		},
		removeImg (i) {
			this.form.fileList.splice(i,1);
		}
	}
}
</script>
<style scoped>
	.policy{
		display:flex;
	}
	.policy-item{
		margin-right: 15px;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployerDadi/common/InsuranceSlip.vue